import React, { useState } from 'react';
import { Modal } from 'antd';
import FeatherIcon from 'feather-icons-react';

import { Button } from '../../../../components/buttons/buttons';

interface ITableButtonDeleteProps {
  pessoaId: string;
  handleDeleteFunction: (pessoaId: string) => Promise<void>;
}

export function TableButtonDelete({ pessoaId, handleDeleteFunction }: ITableButtonDeleteProps) {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenModal = () => setModalIsOpen(true);
  const handleCloseModal = () => setModalIsOpen(false);

  async function handleDelete() {
    setIsLoading(true);
    await handleDeleteFunction(pessoaId);
    handleCloseModal();
    setIsLoading(false);
  }

  return (
    <>
      <Button className="btn-icon" type="danger" shape="circle" onClick={handleOpenModal}>
        <FeatherIcon icon="eye-off" size={16} />
      </Button>

      <Modal
        title="Desativar Registro"
        visible={modalIsOpen}
        onOk={handleDelete}
        onCancel={handleCloseModal}
        okText="Confirmar"
        okType="danger"
        confirmLoading={isLoading}
      >
        <p>Deseja mesmo desativar esse item?</p>
      </Modal>
    </>
  );
}
